import { combineReducers } from "redux";

const defaultGetAnalyticsReport = false;
const getAnalyticsReport = (state = defaultGetAnalyticsReport, action) => {
  switch (action.type) {
    case "GET_ANALYTICS":
      return true;
    case "GET_ANALYTICS_SUCCESS":
    case "GET_ANALYTICS_ERROR":
      return false;
    default:
      return state;
  }
};

const defaultSelectInterval = 'hourly';
const selectInterval = (state = defaultSelectInterval, action) => {
  switch (action.type) {
    case "GET_SELECT_INTERVAL":
      return action.interval;
    case "GET_SELECT_INTERVAL_SUCCESS":
    case "GET_SELECT_INTERVAL_ERROR":
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  getAnalyticsReport,
  selectInterval,
});
